import { doc, getDoc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';
import CountChart from '@src/models/CountChart';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToCountChartByDivision,
  getRouteToCountChartByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class CountChartRepository {
  constructor() {
    this.countChart = new CountChart();
  }

  getCollectionPath(orgId, divId = null, boardId) {
    if (divId) {
      return getRouteToCountChartByDivision(orgId, divId, boardId);
    }
    return getRouteToCountChartByOrg(orgId, boardId);
  }

  async create({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.countChart.setData(data);
      const res = await createOperation(collectionPath, null, this.countChart, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.countChart.setData(data);
      const countChartData = this.countChart.toUpdate();
      await createOperation(collectionPath, chartId, countChartData, ACTIONS.UPDATE);
      return countChartData;
    }).catch(error => {
      throw error;
    });
  }

  async get({ orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const countChartRef = doc(db, collectionPath, chartId);
      const countChartDoc = await getDoc(countChartRef);
      
      if (countChartDoc.exists()) {
        return { id: countChartDoc.id, ...countChartDoc.data() };
      }
      return null;
    }).catch(error => {
      throw error;
    });
  }
}

export default CountChartRepository;
